//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'AgendamentoTarefa',
  components: {
    Confirm,
  },
  data() {
    return {
      agendamentoResources: this.$api.agendamento(this.$resource),
      agendamentos: [],
      agendamento: {},
      dataProximaExecucao: '',
      agendamentoAberto: {},
      dialogForm: false,
      dialogReagendar: false,
      dialogLog: false,
      headers: [
        { text: this.$tc('label.nome', 1), value: 'nome', sortable: false },
        { text: this.$tc('label.periodo', 1), value: 'periodo', sortable: false },
        { text: this.$tc('label.data_proxima_execucao', 1), value: 'dta_proxima_execucao', sortable: false },
        { text: this.$tc('label.tempo', 1), value: 'coeficiente_tempo', sortable: false },
        { text: this.$tc('label.unica_execucao', 1), value: 'ind_unica_execucao', sortable: false },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: false },
        { text: this.$tc('label.opcao', 2), value: 'opcoes', sortable: false },
      ],
      headersLog: [
        { text: this.$tc('label.data', 1), value: 'dta_criacao' },
        { text: this.$tc('label.status', 1), value: 'ind_status' },
        { text: this.$tc('title.erro', 1), value: 'erro' },
      ],
      logs: [],
      periodos: ['MINUTO', 'HORAL', 'DIARIO'],
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
      },

    };
  },
  methods: {
    requestAgendamentos() {
      this.agendamentoResources.listar().then((response) => {
        this.agendamentos = response.data;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
    edit(item) {
      this.agendamento = item;
      this.dialogForm = true;
    },
    reagendar(item) {
      this.agendamento = item;
      this.dataProximaExecucao = item.dta_proxima_execucao;
      this.dialogReagendar = true;
    },
    fechar() {
      this.dialogForm = false;
      this.dialogReagendar = false;
      this.dialogLog = false;
    },
    abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    abrirDialogSalvarReagendar() {
      if (!this.$refs.formReagendar.validate()) return;
      this.$refs.confirmDialogReagendar.open();
    },
    salvar() {
      this.agendamentoResources.atualizar(this.agendamento).then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
        this.requestAgendamentos();
        this.fechar();
      }, (err) => {
        this.$error(this, err);
      });
    },
    salvarReagendar() {
      this.agendamento.dta_proxima_execucao = this.dataProximaExecucao;
      this.agendamentoResources.reagendar(this.agendamento).then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
        this.requestAgendamentos();
        this.fechar();
      }, (err) => {
        this.$error(this, err);
      });
    },
    requestLogs(item) {
      this.agendamentoAberto = item;
      this.agendamentoResources.listarLogs({ id: item.id }).then((response) => {
        this.logs = response.data;
        this.dialogLog = true;
      })
      .catch((err) => {
        this.$error(this, err);
      });
    },
  },
  mounted() {
    this.requestAgendamentos();
  },
};



// WEBPACK FOOTER //
// ./src/spa/administracao/AgendamentoTarefa.vue?vue&type=script&lang=js&